import {createContext, useCallback, useEffect, useMemo, useState} from "react";
import {Box, Snackbar,Alert} from "@mui/material";

export const SnackBarContext = createContext()
const AUTO_DISMISS = 3500

export function SnackBarProvider({children}) {
    const [alerts, setAlerts] = useState([])

    const activeAlertIds = alerts.join(',')

    useEffect(() => {
        if (activeAlertIds.length > 0) {
            const timer = setTimeout(() => setAlerts((alerts) => alerts.slice(0, alerts.length - 1)), AUTO_DISMISS)
            return () => clearTimeout(timer)
        }
    }, [activeAlertIds])

    // стабильные addAlert/value: иначе каждый показ уведомления перерисовывает всех потребителей контекста (все карточки кампаний)
    const addAlert = useCallback((alert) => {
        setAlerts((prevAlerts) => prevAlerts.length >= 3
            ? [...prevAlerts.slice(1), alert]
            : [alert, ...prevAlerts]);
    }, [])
    const value = useMemo(() => ({addAlert}), [addAlert])

    return (
        <SnackBarContext.Provider value={value}>
            {children}
            <div className={"snackbar-wrapper"}>
                {alerts.map((alert, index) =>
                    <Snackbar open={true} key={index}
                              anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
                        <Alert variant="filled" severity={alert.type} >
                            {alert.text}
                        </Alert>
                    </Snackbar>)}
            </div>
        </SnackBarContext.Provider>
    )
}